/**
 * json-render web component implementations — barrel export
 *
 * All 10 catalog components as web-only (Phase 1) implementations.
 *
 * Architecture: existing components (PatternSpotlightCard,
 * TransformationInsightCard, InsightCard, TierCard, TierButton) are
 * React Native. drama-card.tsx and drama-score.tsx export style helpers
 * (not React components). This directory adapts both for web HTML.
 *
 * Task: [#783.S4] NocoDB #787
 * Agent: Diego <diego@liftping.net>
 */

export { AnalysisCard } from "./analysis-card";
export { DramaScore } from "./drama-score-web";
export { DramaCategoryBadge } from "./drama-category-badge";
export { NarrativeBlock } from "./narrative-block";
export { TierBadge } from "./tier-badge";
export { InsightRow } from "./insight-row";
export { SectionDivider } from "./section-divider";
export { ActionButton } from "./action-button";
export { PatternSpotlight } from "./pattern-spotlight-web";
export { TransformationInsight } from "./transformation-insight-web";
export { StyleConsistencyInsight } from "./style-consistency-insight";
export { CommunicationPatternInsight } from "./communication-pattern-insight";
export { ModuleProgress } from "./module-progress";
